import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as JobsStore from '../../store/jobs';
import { JobData } from '../../components/jobs/JobData';

export default connect(
    (state: ApplicationState) => ({
        notifications:
            state.notifications.notifications
                .filter(n => n.ctx == 'jobs.save'),
        ...state.user,
        ...state.identity,
        ...JobsStore.plainActions,
        moduleManager: state.modules.moduleManager,
    }),
    JobsStore.actionCreators,
)(JobData as any) as any;